import { render, staticRenderFns } from "./backend_course.vue?vue&type=template&id=1190f5ac&scoped=true&"
import script from "./backend_course.vue?vue&type=script&lang=js&"
export * from "./backend_course.vue?vue&type=script&lang=js&"
import style0 from "./backend_course.vue?vue&type=style&index=0&id=1190f5ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1190f5ac",
  null
  
)

export default component.exports